// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : changed the backedn api formik value here
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';

import BusinessDetailsActionTypes from './business-details.types';
import {
	createBusinessDetails,
	updateBusinessDetails,
	fetchBusinessDetails,
	deleteBusinessDetails,
	businessListGet,
	checkExistData,
	checkBusinessApprove,
} from './business-details.service';
import {
	addBusinessDetailsSuccess,
	addBusinessDetailsFailure,
	addBusinessDetailsResponseChanged,
	updateBusinessDetailsSuccess,
	updateBusinessDetailsFailure,
	updateBusinessDetailsResponseChanged,
	fetchBusinessDetailsSuccess,
	fetchBusinessDetailsFailure,
	fetchBusinessDetailsResponseChanged,
	deleteBusinessSuccess,
	deleteBusinessFailure,
	deleteBusinessResponseChanged,
	getAllBusinessListSuccess,
	getAllBusinessListFailure,
	getAllBusinessListResponseChanged,
	checkBusinessDetailsExistFailure,
	checkBusinessDetailsExistSuccess,
	isBusinessApproveFailure,
	isBusinessApproveSuccess,
	isBusinessApproveResponseChanged,
	checkBusinessDetailsExistResponseChanged,
} from './business-details.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD BUSINESS DETAILS ******************** */
export function* businessDetailsAdd({ payload }: any) {
	try {
		const {
			companyID,
			businessName,
			businessFormat,
			constitution,
			industry,
			subIndustry,
			yearOfIncorporation,
			dateOfIncorporation,
			noOfDirectors,
			noOfEmployee,
			noOfBranch,
			centerID,
			cinNumber,
			cinRegistrationUrl,
			panNumber,
			panUrl,
			gstNumber,
			leiNumber,
			aadharNumber,
			gstImage,
			propertyType,
			propertyStatus,
			noOfFlors,
			rentalCost,
			purposeOfLoan,
			requestedAmount,
			businessExperience,
			averageMonthlyTurnover,
			expectedFestivalSale,
			stockValue,
			surveyNumber,
			squareFeet,
			headOfficeAddressLine1,
			headOfficeAddressLine2,
			headOfficeStateID,
			headPostOffice,
			headOfficeZip,
			headOfficeCountry,
			registerOfficeAddressLine1,
			registerOfficeAddressLine2,
			registerOfficeState,
			registerOfficeCity,
			registerOfficeZip,
			registerOfficeCountry,
			contactPerson1Name,
			contactPerson1Title,
			contactPerson1Phone,
			contactPerson1Email,
			contactPerson2Name,
			contactPerson2Title,
			contactPerson2Phone,
			contactPerson2Email,
			contactPerson3Name,
			contactPerson3Title,
			contactPerson3Phone,
			contactPerson3Email,
			userID,
			databaseName,
			aadharImageBack,
			aadharImageFront,
			registerOfficePostOffice,
		} = payload;
		const key = 'BusinessDetailsKey';
		const jsonData = {
			RegisterOfficePostOffice: registerOfficePostOffice,
			CompanyID: companyID,
			BusinessName: businessName,
			BusinessFormat: businessFormat,
			Constitution: constitution,
			Industry: industry,
			SubIndustry: subIndustry,
			YearOfIncorporation: yearOfIncorporation,
			DateOfIncorporation: dateOfIncorporation,
			NoOfDirectors: noOfDirectors,
			NoOfEmployee: noOfEmployee,
			NoOfBranch: noOfBranch,
			LocationId: centerID,
			CinNumber: cinNumber,
			CinRegistrationUrl: cinRegistrationUrl,
			PanNumber: panNumber,
			PanUrl: panUrl,
			GstNumber: gstNumber,
			LeiNumber: leiNumber,
			AadharNumber: aadharNumber,
			GstImage: gstImage,
			PropertyType: propertyType,
			PropertyStatus: propertyStatus,
			NoOfFlors: noOfFlors,
			RentalCost: rentalCost,
			PurposeOfLoan: purposeOfLoan,
			RequestedAmount: requestedAmount,
			BusinessExperience: businessExperience,
			AverageMonthlyTurnover: averageMonthlyTurnover,
			ExpectedFestivalSale: expectedFestivalSale,
			StockValue: stockValue,
			SurveyNumber: surveyNumber,
			SquareFeet: squareFeet,
			HeadOfficeAddressLine1: headOfficeAddressLine1,
			HeadOfficeAddressLine2: headOfficeAddressLine2,
			HeadOfficeState: headOfficeStateID,
			HeadOfficePostOffice: headPostOffice,
			HeadOfficeZip: headOfficeZip,
			HeadOfficeCountry: headOfficeCountry,
			RegisterOfficeAddressLine1: registerOfficeAddressLine1,
			RegisterOfficeAddressLine2: registerOfficeAddressLine2,
			RegisterOfficeState: registerOfficeState,
			RegisterOfficeCity: registerOfficeCity,
			RegisterOfficeZip: registerOfficeZip,
			RegisterOfficeCountry: registerOfficeCountry,
			ContactPerson1Name: contactPerson1Name,
			ContactPerson1Title: contactPerson1Title,
			ContactPerson1Phone: contactPerson1Phone,
			ContactPerson1Email: contactPerson1Email,
			ContactPerson2Name: contactPerson2Name,
			ContactPerson2Title: contactPerson2Title,
			ContactPerson2Phone: contactPerson2Phone,
			ContactPerson2Email: contactPerson2Email,
			ContactPerson3Name: contactPerson3Name,
			ContactPerson3Title: contactPerson3Title,
			ContactPerson3Phone: contactPerson3Phone,
			ContactPerson3Email: contactPerson3Email,
			CreatedBy: userID,
			DatabaseName: databaseName,
			AadharImageBack: aadharImageBack,
			AadharImageFront: aadharImageFront,
			Secratekey: key,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(createBusinessDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessDetailsFailure(responseData.data));
		} else {
			yield put(addBusinessDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessDetailsFailure(error));
	}
}

export function* resetAddBusinessResponse() {
	yield put(addBusinessDetailsResponseChanged());
}

export function* onAddBusinessDetails() {
	yield takeLatest(BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_START, businessDetailsAdd);
}

export function* onAddBusinessResponseReset() {
	yield takeLatest(
		BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_RESPONSE_RESET,
		resetAddBusinessResponse,
	);
}
/** *********************  END ADD BUSINESS DETAILS  ******************** */

/** *********************  START UPDATE BUSINESS DETAILS   ******************** */
export function* businessDetailsUpdate({ payload }: any) {
	try {
		const {
			businessID,
			companyID,
			businessName,
			businessFormat,
			constitution,
			industry,
			subIndustry,
			yearOfIncorporation,
			dateOfIncorporation,
			noOfDirectors,
			noOfEmployee,
			noOfBranch,
			centerID,
			cinNumber,
			cinRegistrationUrl,
			panNumber,
			panUrl,
			gstNumber,
			leiNumber,
			aadharNumber,
			gstImage,
			propertyType,
			propertyStatus,
			noOfFlors,
			rentalCost,
			purposeOfLoan,
			requestedAmount,
			businessExperience,
			averageMonthlyTurnover,
			expectedFestivalSale,
			stockValue,
			surveyNumber,
			squareFeet,
			headOfficeAddressLine1,
			headOfficeAddressLine2,
			headOfficeCountry,
			headOfficeZip,
			headOfficeStateID,
			headOfficeCityID,
			registerOfficeAddressLine1,
			registerOfficeAddressLine2,
			registerOfficeState,
			registerOfficeCity,
			registerOfficeZip,
			registerOfficeCountry,
			contactPerson1Name,
			contactPerson1Title,
			contactPerson1Phone,
			contactPerson1Email,
			contactPerson2Name,
			contactPerson2Title,
			contactPerson2Phone,
			contactPerson2Email,
			contactPerson3Name,
			contactPerson3Title,
			contactPerson3Phone,
			contactPerson3Email,
			userID,
			databaseName,
			aadharImageBack,
			aadharImageFront,
		} = payload;
		const key = 'UpdateBusinessDetailsKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			BusinessName: businessName,
			BusinessFormat: businessFormat,
			Constitution: constitution,
			Industry: industry,
			SubIndustry: subIndustry,
			YearOfIncorporation: yearOfIncorporation,
			DateOfIncorporation: dateOfIncorporation,
			NoOfDirectors: noOfDirectors,
			NoOfEmployee: noOfEmployee,
			NoOfBranch: noOfBranch,
			LocationId: centerID,
			CinNumber: cinNumber,
			CinRegistrationUrl: cinRegistrationUrl,
			PanNumber: panNumber,
			PanUrl: panUrl,
			GstNumber: gstNumber,
			LeiNumber: leiNumber,
			AadharNumber: aadharNumber,
			GstImage: gstImage,
			PropertyType: propertyType,
			PropertyStatus: propertyStatus,
			NoOfFlors: noOfFlors,
			RentalCost: rentalCost,
			PurposeOfLoan: purposeOfLoan,
			RequestedAmount: requestedAmount,
			BusinessExperience: businessExperience,
			AverageMonthlyTurnover: averageMonthlyTurnover,
			ExpectedFestivalSale: expectedFestivalSale,
			StockValue: stockValue,
			SurveyNumber: surveyNumber,
			SquareFeet: squareFeet,
			HeadOfficeAddressLine1: headOfficeAddressLine1,
			HeadOfficeAddressLine2: headOfficeAddressLine2,
			HeadOfficeState: headOfficeStateID,
			HeadOfficeCity: headOfficeCityID,
			HeadOfficeZip: headOfficeZip,
			HeadOfficeCountry: headOfficeCountry,
			RegisterOfficeAddressLine1: registerOfficeAddressLine1,
			RegisterOfficeAddressLine2: registerOfficeAddressLine2,
			RegisterOfficeState: registerOfficeState,
			RegisterOfficeCity: registerOfficeCity,
			RegisterOfficeZip: registerOfficeZip,
			RegisterOfficeCountry: registerOfficeCountry,
			ContactPerson1Name: contactPerson1Name,
			ContactPerson1Title: contactPerson1Title,
			ContactPerson1Phone: contactPerson1Phone,
			ContactPerson1Email: contactPerson1Email,
			ContactPerson2Name: contactPerson2Name,
			ContactPerson2Title: contactPerson2Title,
			ContactPerson2Phone: contactPerson2Phone,
			ContactPerson2Email: contactPerson2Email,
			ContactPerson3Name: contactPerson3Name,
			ContactPerson3Title: contactPerson3Title,
			ContactPerson3Phone: contactPerson3Phone,
			ContactPerson3Email: contactPerson3Email,
			CreatedBy: userID,
			DatabaseName: databaseName,
			AadharImageBack: aadharImageBack,
			AadharImageFont: aadharImageFront,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateBusinessDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessDetailsFailure(responseData.data));
		} else {
			yield put(updateBusinessDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessDetailsFailure(error));
	}
}

export function* resetUpdateBusinessResponse() {
	yield put(updateBusinessDetailsResponseChanged());
}

export function* onUpdateBusinessDetails() {
	yield takeLatest(
		BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_START,
		businessDetailsUpdate,
	);
}

export function* onUpdateBusinessResponseReset() {
	yield takeLatest(
		BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_RESPONSE_RESET,
		resetUpdateBusinessResponse,
	);
}
/** *********************  END UPDATE BUSINESS DETAILS ******************** */

/** *********************  START FETCH BUSINESS DETAILS  ******************** */
export function* businessDetailsFetch({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'GetBusinessDetailsKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchBusinessDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessDetailsFailure(responseData.data));
		} else {
			yield put(fetchBusinessDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessDetailsFailure(error));
	}
}

export function* resetFetchBusinessDetailsResponse() {
	yield put(fetchBusinessDetailsResponseChanged());
}

export function* onFetchBusinessDetails() {
	yield takeLatest(BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_START, businessDetailsFetch);
}

export function* onFetchBusinessResponseReset() {
	yield takeLatest(
		BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_RESPONSE_RESET,
		resetFetchBusinessDetailsResponse,
	);
}
/** *********************  END FETCH BUSINESS DETAILS ******************** */

/** *********************  START FETCH BUSINESS DETAILS  ******************** */
export function* businessDelete({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'DeleteBusinessDetailsKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			Secratekey: key,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(deleteBusinessDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessFailure(responseData.data));
		} else {
			yield put(deleteBusinessSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessFailure(error));
	}
}

export function* resetDeleteBusinessResponse() {
	yield put(deleteBusinessResponseChanged());
}

export function* onDeleteBusiness() {
	yield takeLatest(BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_START, businessDelete);
}

export function* onDeleteBusinessResponseReset() {
	yield takeLatest(
		BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_RESPONSE_RESET,
		resetDeleteBusinessResponse,
	);
}
/** *********************  END FETCH BUSINESS DETAILS ******************** */

/** *********************  START GET ALL BUSINESS   ******************** */
export function* allBusinessListGet({ payload }: any) {
	try {
		const { companyID, limit, userID, inputSearch, databaseName } = payload;
		const key = 'GetBusinessListKey';
		const jsonData = {
			CompanyID: companyID,
			Limit: limit,
			UserID: userID,
			SearchData: inputSearch,
			DatabaseName: databaseName,
			Secratekey: key,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(businessListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllBusinessListFailure(responseData.data));
		} else {
			yield put(getAllBusinessListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllBusinessListFailure(error));
	}
}

export function* resetAllBusinessListReset() {
	yield put(getAllBusinessListResponseChanged());
}

export function* onGetBusinessListDetails() {
	yield takeLatest(BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_START, allBusinessListGet);
}

export function* onGetBusinessListResponseReset() {
	yield takeLatest(
		BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_RESPONSE_RESET,
		resetAllBusinessListReset,
	);
}
/** *********************  END GET ALL BUSINESS ******************** */

/********** BUSINESS DETAILS EXIST CHECK START **********/
export function* checkBusinessExistData({ payload }: any) {
	try {
		const { databaseName, companyID, aadharNumber, mobileNumber, isTab, aadharNumberVerify } =
			payload;
		const key = 'VerifyDataKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			AadharNumber: aadharNumber,
			MobileNumber: mobileNumber,
			TabName: isTab,
			AadharNumberVerify: aadharNumberVerify,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(checkExistData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkBusinessDetailsExistFailure(responseData.data));
		} else {
			yield put(checkBusinessDetailsExistSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkBusinessDetailsExistFailure(error));
	}
}

export function* resetBusinessExistCheckReset() {
	yield put(checkBusinessDetailsExistResponseChanged());
}

export function* onBusinessExistCheckDetails() {
	yield takeLatest(
		BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_START,
		checkBusinessExistData,
	);
}

export function* onBusinessExistCheckResponseReset() {
	yield takeLatest(
		BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_RESET,
		resetBusinessExistCheckReset,
	);
}
/********** BUSINESS DETAILS EXIST CHECK END **********/

/*************** START BUSINESS APPROVE DETAILS ******************/
export function* updateBusinessApprove({ payload }: any) {
	try {
		const { databaseName, companyID, userID, businessID, centerID, isApproved, notes } =
			payload;
		const key = 'BusinessApproveKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			CenterID: centerID,
			BusinessID: businessID,
			IsApproved: isApproved,
			Notes: notes,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(checkBusinessApprove, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(isBusinessApproveFailure(responseData.data));
		} else {
			yield put(isBusinessApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(isBusinessApproveFailure(error));
	}
}
export function* resetBusinessApproveReset() {
	yield put(isBusinessApproveResponseChanged());
}

export function* onBusinessApproveDetails() {
	yield takeLatest(BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_START, updateBusinessApprove);
}

export function* onBusinessApproveResponseReset() {
	yield takeLatest(
		BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_RESET,
		resetBusinessApproveReset,
	);
}
/*************** END BUSINESS APPROVE DETAILS ******************/

export function* businessDetailsSaga() {
	yield all([
		call(onAddBusinessDetails),
		call(onAddBusinessResponseReset),
		call(onUpdateBusinessDetails),
		call(onUpdateBusinessResponseReset),
		call(onFetchBusinessDetails),
		call(onFetchBusinessResponseReset),
		call(onDeleteBusiness),
		call(onDeleteBusinessResponseReset),
		call(onGetBusinessListDetails),
		call(onGetBusinessListResponseReset),
		call(onBusinessExistCheckDetails),
		call(onBusinessExistCheckResponseReset),
		call(onBusinessApproveDetails),
		call(onBusinessApproveResponseReset),
	]);
}
